import React, {Fragment, useState, useEffect } from "react";
import Head from 'next/head'
import Header from '@/components/navbars/NavbarZero'
import Container from '@mui/material/Container';
import AboutOne from '@/components/about/TypeOne';
import AboutTwo from '@/components/about/TypeTwo';
import Footer from '@/components/common/Footer';
import { useAppContext } from '../AppContext';
import { useTheme } from '@mui/material/styles'


const renderAboutSection = (type, title) => {
  switch(type){
    case 1: return <AboutOne />;
    case 2: return <AboutTwo />;
    default: return <AboutOne />;
  };
};

export async function getServerSideProps(context) {
  context.res.setHeader(
    'Cache-Control',
    `public, s-maxage=1, stale-while-revalidate=${process.env.CACHE_DURATION}`
  );

  const whiteLabelUrl = context.req.headers.host
  // const whiteLabelUrl = 'sipofsky.com';

  return {
    props: {
      url:whiteLabelUrl,
    }
  }
}

export default function About(props) {
  const theme = useTheme();
  const [loading, setLoading] = useState(true);
  const [themeCss, setThemeCss] = useState(null)
  const { url, themeData, siteData,  themeLoading, siteLoading, themeError, siteError, changeUrl, updateThemeData, updateSiteData } = useAppContext();

  useEffect(()=>{
    changeUrl(props.url)
  },[url]);

  const styles = {
    body: {
      backgroundColor: theme.palette.background.default,
      contrastText: theme.palette.primary.contrastText,
    },
  };

  useEffect(()=>{
    document.body.style.backgroundColor = styles.body.backgroundColor;
    document.body.style.color = styles.body.contrastText;
  },[]);

  useEffect(()=>{
    let custom_css = themeData && themeData ? JSON.parse(themeData && themeData.custom_css): null;
    setThemeCss(custom_css);
    setLoading(false)
  }, [themeData]);

  const AboutContainer = {
    py:2,
    '& h2':{
       fontFamily: themeCss ? (themeCss.theme_primary_font).replace("+"," ") : '',
       fontSize:35,
       fontWeight:700,
       marginBottom:5,
    }
   };

  return (
    <Fragment>
      <Head>
        <title>{siteData && siteData.club_inner[0].restaurantTitle ? siteData.club_inner[0].restaurantTitle : ''} | About Us</title>       
        <meta property="og:title" content={`About Us - ${siteData && siteData.club_inner[0].restaurantTitle ? siteData.club_inner[0].restaurantTitle : ''}`} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={siteData && siteData.club_inner[0].white_label_url ? siteData.club_inner[0].white_label_url+'/about' : ''} />
        <meta property="og:image" content={siteData && siteData.sections[0].home_banner ? siteData.sections[0].home_banner : ''} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:description" content={`Experience the heartbeat of ${siteData && siteData.club_inner[0].restaurantTitle ? siteData.club_inner[0].restaurantTitle : ''}. Discover our passion for unforgettable nights, vibrant energy, and extraordinary experiences. Join us and be part of the excitement that never ends.`} />
        <meta property="og:site_name" content={siteData && siteData.club_inner[0].restaurantTitle ? siteData.club_inner[0].restaurantTitle : ''} />
        <meta property="og:locale" content="en_IN" />
      </Head>
      <Header />
      <Container maxWidth="lg" sx={AboutContainer}>
        {siteData && (
          <>{renderAboutSection(siteData && siteData ? siteData.sections[0].about_type : 1)}</>
        )}
      </Container>
      <Footer />
    </Fragment>
  )
}
